import type { AnyAction } from '@reduxjs/toolkit'

export function isFulfilledAction(action: AnyAction, isFulfilled: (action: AnyAction) => boolean) {
  if (isFulfilled(action)) {
    return action.type.endsWith('/fulfilled')
  }
  return false
}
export function isPendingAction(action: AnyAction, isPending: (action: AnyAction) => boolean) {
  if (isPending(action)) {
    return action.type.endsWith('/pending')
  }
  return false
}
export function isRejectedAction(action: AnyAction, isRejected: (action: AnyAction) => boolean) {
  if (isRejected(action)) {
    return action.type.endsWith('/rejected')
  }
  return false
}
